import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // console.log("connect::contact-form-controller");

    const el = this.element;
    const turboStream = el.querySelector("turbo_stream")

    const siteKey = el.dataset.recaptchaSiteKey;

    if (siteKey) {
      // En el contenedor y no en el form: la respuesta de Turbo sustituye el form,
      // y sin esto reenviar tras un error salia sin token y reCAPTCHA lo rechazaba.
      el.addEventListener("submit", (event) => {
        const form = event.target;

        if (form.dataset.captchaDone || !window.grecaptcha) {
          delete form.dataset.captchaDone;
          return;
        }

        event.preventDefault();

        grecaptcha.ready(() => {
          grecaptcha.execute(siteKey, { action: "submit" }).then((token) => {
            const input = form.querySelector("input[name='message[recaptcha_token]']");
            if (input) input.value = token;
            form.dataset.captchaDone = "1";
            form.requestSubmit();
          });
        });
      });
    }

    // Iniciados frente a enviados: el abandono del formulario.
    el.addEventListener("focusin", () => {
      if (window.umami) {
        window.umami.track("Formulario iniciado");
      }
    }, { once: true });

    turboStream.addEventListener("turbo:submit-start", function() {
      el.classList.add("sending");
    });

    turboStream.addEventListener("turbo:submit-end", (event) => {
      el.classList.remove("sending");

      if (window.umami) {
        const status = event.detail.fetchResponse && event.detail.fetchResponse.statusCode;
        window.umami.track(status == 202 ? "Contacto a revisar" : event.detail.success ? "Contacto enviado" : status == 403 ? "Contacto bloqueado" : "Contacto fallido");
      }

      if (event.detail.success) {
        el.classList.add("success");

        window.setTimeout(() => {
          el.classList.remove("success");

          let inputs = el.querySelectorAll("input, textarea");

          for (let input of inputs) {
            if (input.type == "submit") {
              continue;
            }

            if (input.type == "checkbox") {
              input.checked = false;
              continue;
            }

            input.value = "";
          }

        }, 6000);
      }
    });
  }
}
